export function ServiceAreaCities() {
  const cities = [
    { name: 'Long Beach', url: '/service-areas/long-beach' },
    { name: 'Ilwaco', url: '/service-areas/ilwaco' },
    { name: 'Ocean Park', url: '/service-areas/ocean-park' },
    { name: 'Westport', url: '/service-areas/westport' },
    { name: 'Aberdeen', url: '/service-areas/aberdeen' },
    { name: 'Hoquiam', url: '/service-areas/hoquiam' },
    { name: 'Raymond', url: '/service-areas/raymond' },
    { name: 'South Bend', url: '/service-areas/south-bend' },
    { name: 'Cathlamet', url: '/service-areas/cathlamet' }
  ];

  return (
    <section className="py-16 bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
            Serving All of <span className="text-teal-600">SW Washington</span>
          </h2>
          <p className="text-slate-600">
            Quality used cars delivered throughout Pacific County and Grays Harbor
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {cities.map((city, index) => (
            <a
              key={index}
              href={city.url}
              className="inline-flex items-center gap-2 bg-slate-100 hover:bg-teal-100 border border-slate-200 hover:border-teal-300 text-slate-700 hover:text-teal-700 px-5 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-map-pin-line text-lg"></i>
              {city.name}
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a 
            href="/service-areas" 
            className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-semibold transition-colors cursor-pointer"
          >
            View All Service Areas
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default ServiceAreaCities;
